import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import StyledButton from '../StyledButton/StyledButton';

import styles from './SaveCancelButtonsContainer.module.css';

type SaveCancelButtonsContainerProps = {
   onSave: () => void;
   onCancel: () => void;
   className?: string;
};

const SaveCancelButtonsContainer = ({
   onSave,
   onCancel,
   className,
}: SaveCancelButtonsContainerProps) => {
   const { t } = useTranslation();

   return (
      <div className={classNames(styles.container, className)}>
         <StyledButton
            type="button"
            text={t('common.save')}
            onClick={onSave}
            variant="filled-primary"
            className={styles.btn}
         />
         <StyledButton
            type="button"
            text={t('common.reject')}
            onClick={onCancel}
            variant="outlined-primary"
            className={styles.btn}
         />
      </div>
   );
};

export default SaveCancelButtonsContainer;
